import * as React from 'react';
import { Dialog } from 'primereact/dialog';
import { Button } from "primereact/button";

const confirmDialog = (props) => {
  return (
    <Dialog header={props.headerTitle} width="350px"
      modal={true}
      visible={props.isVisible}
      onHide={props.noClick}
      footer={
        <div>
          <Button label="Yes" icon="pi pi-check" onClick={props.yesClick} />
          <Button label="No" icon="pi pi-times" onClick={props.noClick} />
        </div>
      }>
      {props.children}
    </Dialog>
  )
}

export default confirmDialog;